module.exports = __webpack_public_path__ + "img/qdhsd.626a0a6b.png";